import { lazy } from 'react';
const PlanillasParaPresentacionesPage = lazy(() =>
  import('../../pages/PlanillasParaPresentaciones'),
);
const SobreNosotrosPage = lazy(() => import('../../pages/AboutUs'));
const SucursalesPage = lazy(() => import('../../pages/Sucursales'));
const InfoSwissPage = lazy(() => import('../../pages/InfoSwiss'));
const RevistaAequalisPage = lazy(() => import('../../pages/RevistaAequalis'));
const SerPrestadorPage = lazy(() => import('../../pages/SerPrestador'));
const LineasDeDenunciasPage = lazy(() => import('../../pages/LineasDeDenuncias'));
const DatosImpositivosPage = lazy(() => import('../../pages/TaxData'));
const NuevasFormasDeConectarnos = lazy(() => import('../../pages/NuevasFormasDeConectarnos'));
const DocumentacionAutorizacionesPage = lazy(() =>
  import('../../pages/DocumentacionAutorizaciones'),
);
const GuiasPracticaClinicaPage = lazy(() => import('../../pages/GuiasPracticaClinica'));
const CredencialDigitalPage = lazy(() => import('../../pages/CredencialDigital'));
const CopaymentsPage = lazy(() => import('../../pages/Copayments'));
const DocumentsPage = lazy(() => import('../../pages/Documents'));

const usefulInformationRoutes = [
  {
    title: 'Planillas para Presentaciones',
    path: 'informacionutil/planillas-presentaciones',
    permission: 'planillas-presentaciones',
    component: PlanillasParaPresentacionesPage,
    isPrivate: true,
  },
  {
    title: 'Sobre Nosotros',
    path: 'informacionutil/nosotros',
    component: SobreNosotrosPage,
    isPrivate: false,
  },
  {
    title: 'Sucursales',
    path: 'informacionutil/mapa-de-sucursales',
    component: SucursalesPage,
    isPrivate: false,
  },
  {
    title: 'Info Swiss',
    path: 'informacionutil/novedades',
    component: InfoSwissPage,
    isPrivate: false,
  },
  {
    title: 'Revista Aequalis',
    path: 'informacionutil/aequalis',
    component: RevistaAequalisPage,
    isPrivate: false,
  },
  {
    title: 'Ser Prestador',
    path: 'informacionutil/ser-prestador',
    component: SerPrestadorPage,
    isPrivate: false,
  },
  {
    title: 'Documentación para Autorizaciones',
    path: 'informacionutil/documentacion-para-autorizaciones',
    component: DocumentacionAutorizacionesPage,
    permission: 'documentacion-para-autorizaciones',
    isPrivate: true,
  },
  {
    title: 'Guías de Prácticas Clínicas',
    path: 'informacionutil/practicas',
    component: GuiasPracticaClinicaPage,
    permission: 'practicas',
    isPrivate: true,
  },
  {
    title: 'Lineas de Denuncias',
    path: 'informacionutil/fraude',
    component: LineasDeDenunciasPage,
    isPrivate: false,
  },
  {
    title: 'Datos Impositivos',
    path: 'informacionutil/datos-impositivos',
    component: DatosImpositivosPage,
    isPrivate: false,
  },
  {
    title: 'Nuevas Formas de conectarnos',
    path: 'informacionutil/conectarnos',
    component: NuevasFormasDeConectarnos,
    isPrivate: false,
  },
  {
    title: 'Credencial Digital',
    path: 'informacionutil/credencial-digital',
    component: CredencialDigitalPage,
    isPrivate: false,
  },
  {
    title: 'Cobrá el copago en cada consulta',
    path: 'informacionutil/copagos',
    component: CopaymentsPage,
    isPrivate: false,
  },
  {
    title: 'Documentos y Formularios',
    path: 'informacionutil/documentos',
    component: DocumentsPage,
    isPrivate: false,
  },
];

export default usefulInformationRoutes;
